import { render, staticRenderFns } from "./ReenterRoom.vue?vue&type=template&id=2cbcc6cc&"
import script from "./ReenterRoom.vue?vue&type=script&lang=js&"
export * from "./ReenterRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports